const getters = {
  token: state => state.user.token,
  roles: state => state.user.roleList,
  auths: state => state.user.authList,
  userInfo: state => state.user.userInfo,
  cacheView: state => state.view.cacheView,
  menus: state => state.router.menus,
  isAddedRoute: state => state.router.isAddedRoute
}

export default getters
